import { useMutation } from 'react-query';
import axios from 'axios';
import { useTokenStore } from '../../storage/tokenState';
import { CREATE_CHECKOUT_ORDER } from '../../appConstants/APIEndpoint';
import { LANGUAGE } from '../../constant';
import { getSubscriptionBaseUrl } from '../../utils/apiConfig';

interface CreateCheckoutOrderRequest {
  amount: number;
  constraintId: string;
  customerVpa?: string;
  instrumentType: string;
  isNewSavedCard: boolean;
  paymentMode: string;
}

interface CreateCheckoutOrderResponse {
  en: string;
  response: {
    success: boolean;
    upiAdditionError?: string;
    data?: {
      orderId: string;
      amount: number;
      customerId: string | null;
      pgName: string;
      authToken?: string; // Auth token for PhonePe API
      qrUrl?: string;
      mandateFlowData?: {
        mandateUri?: string;
      };
      expiryData?: {
        timestamp?: number;
      };
    };
    screenError?: {
      title: string;
      serverMsg: string;
    };
  };
}

export const useCreateCheckoutOrder = () => {
  const { token } = useTokenStore();

  const mutation = useMutation<CreateCheckoutOrderResponse, Error, CreateCheckoutOrderRequest>(
    async (requestData: CreateCheckoutOrderRequest) => {
      // Get base URL from environment (trailing slash already removed in apiConfig)
      const baseUrl = getSubscriptionBaseUrl();
      const fullUrl = `${baseUrl}${CREATE_CHECKOUT_ORDER.url}`;
      
      console.log('Calling createCheckoutOrder API:', {
        url: fullUrl,
        requestData,
        hasToken: !!token?.accessToken
      });

      const response = await axios.post(fullUrl, requestData, {
        headers: {
          'Authorization': token?.accessToken || '',
          'x-zupee-source': 'web',
          // 'x-zupee-env': 'cse',
          // "z-stage-env-id":"stv-prya80a3bac",
          'language': localStorage.getItem("language") || LANGUAGE,
          'Content-Type': 'application/json',
          'Package-Name': process.env.REACT_APP_APPPACKAGENAME || 'pwa.verticalbyzupee.com',
          'appname': process.env.REACT_APP_APP_NAME || 'pwa.verticalbyzupee.com',
        }
      });

      console.log('createCheckoutOrder Response:', response.data);
      return response.data;
    }
  );

  return {
    createOrderAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    data: mutation.data,
    error: mutation.error
  };
};

